import "./SkeletonCardSearch.css";

const SearchLoaderCard = () => {
  return (
    <>
      {[...Array(3)].map((_, index) => (
        <div
          key={index}
          className="d-flex flex-column p-3 rounded mb-3 bg-white"
        >
          {/* Top Section */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
            {/* Left: Avatar & Info */}
            <div className="d-flex mb-3 mb-md-0">
              {/* Avatar */}
              <div
                className="skeleton rounded-circle me-3"
                style={{ width: 60, height: 60 }}
              ></div>

              {/* Info */}
              <div>
                <div
                  className="skeleton mb-1"
                  style={{ width: 180, height: 16 }}
                ></div>
                <div
                  className="skeleton mb-2"
                  style={{ width: 150, height: 14 }}
                ></div>

                <div
                  className="d-flex flex-wrap align-items-center text-muted"
                  style={{ fontSize: "0.85rem" }}
                >
                  <div
                    className="skeleton me-3 mb-1"
                    style={{ width: 180, height: 12 }}
                  ></div>
                  <div
                    className="skeleton me-3 mb-1"
                    style={{ width: 140, height: 12 }}
                  ></div>
                  <div
                    className="skeleton mb-1"
                    style={{ width: 120, height: 12 }}
                  ></div>
                </div>
              </div>
            </div>

            {/* Right: Logo + Circle */}
            <div className="d-flex align-items-center ms-md-auto">
              <div
                className="skeleton me-3"
                style={{ width: 100, height: 40, borderRadius: 6 }}
              ></div>
              <div
                className="skeleton rounded-circle"
                style={{ width: 60, height: 60 }}
              ></div>
            </div>
          </div>

          {/* Divider */}
          <hr className="my-3" />

          {/* Skills */}
          <div className="d-flex flex-wrap gap-2">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="skeleton rounded-pill"
                style={{ width: 100, height: 24 }}
              ></div>
            ))}
            <div
              className="skeleton rounded-pill bg-secondary"
              style={{ width: 80, height: 24 }}
            ></div>
          </div>
        </div>
      ))}
    </>
  );
};

export default SearchLoaderCard;
